import * as tslib_1 from "tslib";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
var NewContent = /** @class */ (function (_super) {
    tslib_1.__extends(NewContent, _super);
    /**
     * Class constructor
     * @param {any} props
     * @returns {void}
     */
    function NewContent(props) {
        return _super.call(this, props) || this;
    }
    /**Check if the new content component should be displayed */
    NewContent.prototype.ShowNewContentComponent = function () {
        try {
            return sessionStorage.getItem('new-version') === 'true';
        }
        catch (e) {
            return false;
        }
    };
    /**Redirect page to repo. Repo will redirect back setting the new service worker online */
    NewContent.prototype.Reload = function () {
        try {
            sessionStorage.removeItem('new-version');
        }
        catch (e) {
            console.error('Sessio storage error');
        }
        window.location.href = process.env.REACT_APP_REPO + "/webapp-update.html";
    };
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     * */
    NewContent.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { id: "new-content", className: "" + (this.ShowNewContentComponent() ? '' : 'd-none'), onClick: function (e) { _this.Reload(); } },
            React.createElement(FormattedMessage, { id: "generics.pwa.new-version" }),
            "\u00A0",
            React.createElement(FontAwesomeIcon, { icon: ['far', 'sync-alt'], transform: "down-1 right-2" })));
    };
    return NewContent;
}(React.PureComponent));
export { NewContent };
//# sourceMappingURL=NewContent.js.map